import { ICancelSubscriptionPreview, IGetPlanBlocklistArgs, IGetPlanBlocklistResponse } from '@reolink-cloud/interface';
import { httpManager as http } from '@/plugins/HttpManager';

export const transferSubscription = ( data: any ): Promise<Record<string, any>> => {

    return new Promise(( resolve, reject ) => {

        http.post( `/shop/orders`, data ).then( res => {

            resolve( res.data );

        }).catch( err => {

            console.error( err );
            reject( err );

        });

    });

};

// 预览取消订阅操作的退款信息
export const previewRefundInfo = ( id: string ): Promise<ICancelSubscriptionPreview> => {

    return new Promise(( resolve, reject ) => {

        http.post( `/cloud/subscriptions/cancellation/preview`, {
            id
        }).then( res => {

            resolve( res.data );

        }).catch( err => {

            console.error( err );
            reject( err );

        });

    });

};

export const deleteTrafficProduct = ( data ) => {

    return new Promise(( resolve, reject ) => {

        http.post( `/cloud/traffic/package/cancellation`, data ).then( res => {

            resolve( res );

        }).catch( err => {

            console.error( err );
            reject( err );

        });

    });

};
// 预览取消订阅操作的退款信息
export const previewTrafficRefundInfo = ( id: string ): Promise<Record<string, any>> => {

    return new Promise(( resolve, reject ) => {

        http.get( `/cloud/traffic/packages/${id}/cancellation/preview` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            console.error( err );
            reject( err );

        });

    });

};

function calcStartOfNextCycle( cycleStartedAt, cycleUnit, cycleInterval ): number | void {

    switch ( cycleUnit ) {

        case 'day':
            return cycleStartedAt + cycleInterval * 86400000;
        case 'week':
            return cycleStartedAt + cycleInterval * 86400000 * 7;
        case 'month':
            return getSameDayOfNeighboringMonth( cycleStartedAt, cycleInterval ).getTime();
        case 'year':
            return getSameDayOfNeighboringMonth( cycleStartedAt, cycleInterval * 12 ).getTime();

    }

}

function getSameDayOfNeighboringMonth( cycleStartedAt: number, cycleInterval: number ): Date {

    const date = new Date( cycleStartedAt );

    const nextDate = new Date(
        date.getFullYear(),
        date.getMonth() + cycleInterval,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    );

    const rest = ( date.getMonth() + cycleInterval ) % 12;

    if ( rest < 0 ) {

        if ( rest + 12 === nextDate.getMonth()) {

            return nextDate;

        }

    } else {

        if ( rest === nextDate.getMonth()) {

            return nextDate;

        }

    }

    return new Date(
        date.getFullYear(),
        date.getMonth() + cycleInterval + 1,
        0,
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    );

}

/**
 *
 * @param {*} sub
 *
 * 免费套餐续费，需在剩余时间在一个周期之内
 */
export const freePlanRenewable = ( sub: Record<string, any> ): boolean => {

    if ( !sub || sub.status === 'inactive' ) {

        return true;

    }
    const { frequency, unit } = sub.plan.cycle.interval;
    const oneCycleTime = calcStartOfNextCycle( new Date().getTime(), unit, frequency );
    const endingAt = sub.endingAt;
    return oneCycleTime > endingAt;

};

export const getPlanBlockList = async ( args: IGetPlanBlocklistArgs ): Promise<IGetPlanBlocklistResponse> => {

    const { data } = await http.post( '/cloud/plans/blocklist', args );
    return data;

};
